/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Link, Redirect, useHistory } from 'react-router-dom';
import {
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap';
import { Helmet } from 'react-helmet';
import TheLayout from '../../layout/TheLayout';
import ButtonComponent from '../Util/ButtonComponent';
import {
  login,
} from '../../redux/actions/auth';

const keywords = ['TERRA', 'login', '会員登録'];

const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const errorMessage = useSelector((state) => state.auth.errorMessage, shallowEqual);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const dispatch = useDispatch();
  const { search } = history.location;
  const paramsUrl = new URLSearchParams(search);
  const type = paramsUrl.get('type');

  const onSubmit = () => {
    const params = {
      company_id: Number(process.env.REACT_APP_COMPANY_ID),
      email,
      password,
    };
    dispatch(login(params));
  };

  if (isLoggedIn) {
    if ((type) && type === 'purchase') {
      return <Redirect to="/apply?typeLink=signin" />;
    }
    return <Redirect to="/mypage" />;
  }

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>メンバーログイン｜株式会社TERRA</title>
      </Helmet>
      <div className="login">
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb bg-transparent" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>メンバーログイン</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="login container" style={{ minHeight: '40vh', paddingTop: '10vh', paddingBottom: '5vh' }}>
          <div
            className="bg-white py-3 px-3 px-lg-5"
            style={{
              width: '100%',
              borderRadius: '1rem',
            }}
          >
            {
              errorMessage === ''
                ? ''
                : <Alert color="danger">{errorMessage}</Alert>
            }
            <FormGroup>
              <Label>
                メールアドレス
              </Label>
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {
                  passwordError !== ''
                    ? (
                      <span style={{ color: '#ff0000', fontSize: '12px' }}>
                        {passwordError}
                      </span>
                    )
                    : ''
                }
            </FormGroup>
            <FormGroup>
              <Label>
                パスワード
              </Label>
              <Input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {
                  passwordError !== ''
                    ? (
                      <span style={{ color: '#ff0000', fontSize: '12px' }}>
                        {passwordError}
                      </span>
                    )
                    : ''
                }
            </FormGroup>
            <br />
            <ButtonComponent
              background="#224B71"
              borderColor="#224B71"
              color="white"
              width="50%"
              onClick={() => onSubmit()}
            >
              ログイン
            </ButtonComponent>
            <br />
            <Link
              className="d-block text-center"
              to="/reset_password"
              style={{
                color: 'rgb(34, 75, 113)',
              }}
            >
              パスワードをお忘れですか？
            </Link>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Login;
